import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TransmissionStation } from '../models/transmission-station.model';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';

@Injectable({
  providedIn: 'root',
})
export class TransmissionStationService {
  private pathApi: string;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
    this.pathApi = this.config.pathApi + 'transmissionStation/';
  }

  getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn);
  }

  getAllForMappings(): Observable<any> {
    return this.http.get(`${this.pathApi}getAllForMappings`);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`);
  }

  downloadFile(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}downloadFile`, dataIn);
  }

  save(ts: TransmissionStation): Observable<any> {
    return this.http.post(`${this.pathApi}save`, ts);
  }

  getAllForSelect(utilityId: number | null = null): Observable<any> {
    if (utilityId) {
      return this.http.get(`${this.pathApi}getAllForSelect/${utilityId}`, {
        observe: 'response',
      });
    } else {
      return this.http.get(`${this.pathApi}getAllForSelect`, {
        observe: 'response',
      });
    }
  }

  getV3TsStats(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}getV3TsStats`, obj, { headers: this.headers, observe: 'response' });
  }
}
